import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
  styled,
} from '@mui/material';

export const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'isHighlighted',
})<{ isHighlighted?: boolean; customBackground: string }>(
  ({ theme, isHighlighted, customBackground }) => ({
    width: '298px',
    marginTop: theme.spacing(2),
    background:
      customBackground ||
      (isHighlighted ? theme.palette.primary.main : theme.palette.primary.dark),
  })
);

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: `${theme.spacing(2.25)} ${theme.spacing(4)}`,
}));

export const StyledCardAction = styled(CardActions)(({ theme }) => ({
  padding: 0,
  position: 'relative',
  '& svg': {
    position: 'absolute',
    bottom: 0,
    right: theme.spacing(4),
  },
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h6.fontSize,
  lineHeight: theme.spacing(3.25),
  color: theme.palette.common.white,
  fontWeight: theme.typography.fontWeightBold,
}));

export const CardSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  lineHeight: theme.spacing(2.5),
  color: theme.palette.common.white,
  paddingTop: theme.spacing(1),
}));

export const CardButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  color: theme.palette.primary.main,
  margin: theme.spacing(4, 0, 3, 4),
  fontSize: theme.typography.fontSize,
  padding: `${theme.spacing(0.6)} ${theme.spacing(2)}`,
  '&:hover': {
    backgroundColor: theme.palette.grey[50],
    color: theme.palette.primary.main,
  },
}));
